// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1exS-","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__20hJb"};